/**
 * The base path a previewed app announces (`molecule:base`), made safe to prepend to a route.
 *
 * The announcement comes from the tenant's own page, and the IDE builds navigation as
 * `<preview origin> + base + path`. A base such as `@evil.com/` or `.evil.com/` would turn that
 * into a different host, so only a plain absolute path is accepted.
 *
 * @param raw - The announced base.
 * @returns The base with a trailing slash, or null when it is not a plain absolute path.
 */
export function sanitizeAppBase(raw: unknown): string | null {
  if (typeof raw !== 'string' || raw.length > 200) return null
  if (!/^\/[A-Za-z0-9._~\-/]*$/.test(raw) || raw.startsWith('//')) return null
  return raw.endsWith('/') ? raw : `${raw}/`
}
